var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.85 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #898989;\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u6587\\u5B57",
    "data-name": "\\u6587\\u5B57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20,9.21v10.19c0,.33-.26.59-.59.59h-11.3c-.31,0-.57-.26-.57-.59v-7.9h-3.81v7.9c0,.33-.26.59-.57.59h-1.62c-.31,0-.57-.26-.57-.59v-10.09l.33.21c.18.13.44.15.64,0l1.88-1.29,1.85,1.29c.21.13.46.15.67,0l1.88-1.29,1.85,1.29c.18.13.46.15.64,0l1.88-1.29,1.88,1.29c.18.13.44.15.64,0l1.88-1.29,1.85,1.29c.21.13.46.15.67,0l.46-.31ZM5.51,0l-1.06,5.51v1.78l1.57,1.08,1.67-1.16v-1.78l.33-5.43h-2.52ZM3.32,7.21l-.03-1.7c0-.05,0-.1.03-.15L4.35,0H1.83L0,5.43v1.83l1.62,1.11,1.7-1.16ZM9.19,0l-.36,5.48v1.8l1.6,1.08,1.67-1.16v-1.72l-.31-5.48h-2.6ZM12.92,0l.31,5.43v1.85l1.6,1.08,1.67-1.16v-1.7l-1.08-5.51h-2.5ZM16.58,0l1.06,5.35v1.93l1.57,1.08,1.65-1.11v-1.8l-2.24-5.46h-2.03ZM16.83,11.76h-5.35v3.17h5.35v-3.17Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.a3dd6dc3a210402861ed61d0264baa57.svg";
export { ForwardRef as ReactComponent };